module.exports = __webpack_public_path__ + "img/task_tips1.c2799a98.png";